import { DATE_FULL_FORMAT_FROM_TIME } from '../../../../../constants/date'
import { TableDateCell, TableEmptyCell } from '../../../../Table'
import { ApplicantProfileEmailsColumnName } from '../RentalPortalApplicantProfileEmails.constants'

import { ApplicantProfileEmailsMessageCell } from './ApplicantProfileEmailsMessageCell'
import { ApplicantProfileEmailsParticipantCell } from './ApplicantProfileEmailsParticipantCell'

export function getIsApplicantProfileEmailsRowActive({ focusedRow, item }) {
  return focusedRow === item.id
}

export function renderApplicantProfileEmailsCell({ item, name, ...restProps }) {
  switch (name) {
    case ApplicantProfileEmailsColumnName.Participant:
      return (
        <ApplicantProfileEmailsParticipantCell {...restProps} item={item} />
      )

    case ApplicantProfileEmailsColumnName.SentAt:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_FULL_FORMAT_FROM_TIME}
          unread={!item.is_read}
          useTodayFormat={false}
          value={item.sent_at}
        />
      )

    case ApplicantProfileEmailsColumnName.Subject:
      return <ApplicantProfileEmailsMessageCell {...restProps} item={item} />

    default:
      return <TableEmptyCell {...restProps} />
  }
}
